<template>
  <b-container fluid>
    <b-row align-h="center" class="mx-3">
      <b-col>
        <b-row class="mb-3">
          <b-col>
            <Header
              :title="client ? client.name : ''"
              :subTitle="client ? client.client_num : ''"
              :ready="ready"
              :isLoading="isLoading"
            >
              <template #actions>
                <b-row v-if="isLoading">
                  <b-col class="text-info">
                    <b-spinner type="grow" class="mr-2" />
                  </b-col>
                </b-row>
                <b-row v-else-if="ready && client.sap_valid" class="mr-2">
                  <b-col>
                    <Button
                      v-if="isDev || isClientAdmin"
                      variant="red"
                      class="ml-2 mt-2"
                      :disabled="!ready"
                      @click="confirmModal = true"
                    >
                      <b-spinner v-if="isInactivatingClient" small type="grow" class="mr-2" />
                      <font-awesome-icon v-else :icon="['far', 'exclamation']" fixed-width />
                      <span class="pl-1">{{ isInactivatingClient ? 'Inactivando' : 'Inactivar' }}</span>
                    </Button>
                    <Button
                      variant="blue"
                      class="ml-2 mt-2"
                      :disabled="!ready"
                      @click="$router.push(`/app/prod/llamadas-servicio/nueva?client=${id}`)"
                    >
                      <font-awesome-icon :icon="['fas', 'tools']" size="lg" fixed-width />
                      <span class="pl-1">Crear OS</span>
                    </Button>
                    <Button
                      v-if="client.client_num && client.client_num.charAt(0) == 'C'"
                      variant="yellow"
                      class="ml-2 mt-2"
                      :disabled="!client.sap_valid || !ready"
                      @click="$router.push({ name: 'ClientUpdate', params: { id: id}})"
                    >
                      <font-awesome-icon :icon="['far', 'edit']" fixed-width />
                      <span class="pl-1">Editar</span>
                    </Button>
                  </b-col>
                </b-row>
                <b-row v-else class="mr-2">
                  <b-col>
                    <div v-if="ready && client.sap_frozen">
                      <p class="name text-danger mb-1">INACTIVO</p>
                      <p v-if="client.sap_frozen_remarks" class="mb-1">[ {{ client.sap_frozen_remarks }} ]</p>
                    </div>
                    <div v-else>
                      <p class="name text-danger mb-1">INVÁLIDO</p>
                      <p v-if="ready" class="mb-1">Este cliente esta inválido en SAP</p>
                    </div>
                  </b-col>
                </b-row>
              </template>
            </Header>
          </b-col>
        </b-row>

        <!-- dashboard cards & buttons -->
        <b-row>
          <b-col>
            <ClientDashboards
              :isLoading="isLoading || isDashboardLoading"
              :ready="ready"
              @update-dashboards="updateDashboards"
              @display-alert="displayAlert"
            />
          </b-col>
        </b-row>

        <!-- General info tabs -->
        <b-row align-h="center" class="mb-2">
          <b-col md="12">
            <p class="text-muted fs-20 p-0 mb-2">Información General</p>

            <b-card no-body class="tabs-card">
              <b-tabs
                card
                v-model="bTabIndex"
                no-fade
                nav-class="mr-2 mb-1 bg-light fs-17 border-0"
                active-nav-item-class="fs-17 border rounded border-secondary"
              >
                <b-tab :title-link-class="bTabClass(0)" no-body title="Info General">
                  <b-card-text>
                    <b-container fluid>
                      <b-row v-if="isLoading || !ready" style="min-height: 220px">
                        <b-container fluid class="fs-17">
                          <b-row align-h="center" class="h-100 justify-content-center align-items-center">
                            <span v-if="isLoading" class="text-info">
                              <b-spinner small type="grow" class="mr-2" />
                              Cargando datos del cliente...
                            </span>
                            <span v-else class="text-danger">Error al cargar datos del cliente, intente de nuevo</span>
                          </b-row>
                        </b-container>
                      </b-row>
                      <b-row v-else style="min-height: 220px">
                        <b-col lg="6" sm="12">
                          <table v-if="ready" class="table table-borderless table-show table-sm"  style="font-size: 1rem">
                            <tr>
                              <td style="width: 230px">Tipo de ID:</td>
                              <td v-if="client.sap_gln">{{ cedulaType }}</td>
                              <td v-else class="text-danger"> Sin información</td>
                            </tr>
                            <tr>
                              <td>Número cédula:</td>
                              <td v-if="client.cedula">{{ client.cedula }}</td>
                              <td v-else class="text-danger"> Sin información</td>
                            </tr>
                            <tr>
                              <td>Categoría cliente:</td>
                              <td v-if=" client.rank">{{ client.rank }}</td>
                              <td v-else class="text-danger"> Sin información</td>
                            </tr>
                            <tr>
                              <td>Tipo socio negocios:</td>
                              <td>
                                <span v-if="client.client_type == 'cCompany'">Sociedades</span>
                                <span v-else-if="client.client_type == 'cPrivate'">Privado</span>
                                <span v-else class="text-danger"> Sin información</span>
                              </td>
                            </tr>
                            <tr>
                              <td>Sector:</td>
                              <td v-if="client.sector">{{ client.sector }}</td>
                              <td v-else class="text-danger"> Sin información</td>
                            </tr>
                            <tr>
                              <td>Subsector:</td>
                              <td v-if="client.subsector">{{ subSectorName }}</td>
                              <td v-else class="text-danger"> No definido</td>
                            </tr>
                            <tr v-if="isDev">
                              <td>Serie <small>(Dev only)</small>:</td>
                              <td>
                                <span v-if="client.sap_series">{{ client.sap_series }}</span>
                                <span v-else class="text-muted">Sin información</span>
                              </td>
                            </tr>
                          </table>
                        </b-col>
                        <b-col lg="6" sm="12">
                          <table v-if="ready" class="table table-borderless table-show table-sm"  style="font-size: 1rem">
                            <tr>
                              <td>Condiciones de pago:</td>
                              <td v-if="client.payment_terms">{{ client.payment_terms }}</td>
                              <td v-else class="text-danger"> Sin información</td>
                            </tr>
                            <tr>
                              <td style="width: 230px">Asesor asignado:</td>
                              <td>
                                <span v-if="client.salesperson" :class="{'text-danger': !client.salesperson.status}">
                                  {{ client.salesperson | concatName2 }}
                                </span>
                                <span v-else class="text-danger">-</span>
                              </td>
                            </tr>
                            <tr>
                              <td>Asesor TKM:</td>
                              <td>
                                <span v-if="client.telemarketer" :class="{'text-danger': !client.telemarketer.status}">
                                  {{ client.telemarketer | concatName2 }}
                                </span>
                                <span v-else class="text-danger">-</span>
                              </td>
                            </tr>
                            <tr>
                              <td>Gestor de cobro:</td>
                              <td v-if="client.collection_manager">{{ client.collection_manager }}</td>
                              <td v-else class="text-danger"> - </td>
                            </tr>
                            <tr>
                              <td>Portal web:</td>
                              <td v-if="isValidUrl(client.website_url)">
                                <a :href="client.website_url" target="_blank">{{client.website_url}}</a>
                              </td>
                              <td v-else-if="client.website_url">
                                <span>{{ client.website_url }}</span>
                              </td>
                              <td v-else class="text-danger"> - </td>
                            </tr>
                            <tr>
                              <td>Tipo de Impuesto:</td>
                              <td v-if="clientTaxCode">
                                <span>{{clientTaxCode}}</span>
                              </td>
                              <td v-else class="text-danger"> - </td>
                            </tr>
                            <tr>
                              <td>Notas:</td>
                              <td>
                                <b-textarea
                                  disabled
                                  id="client-notes"
                                  v-model="client.notes"
                                  placeholder="Sin comentarios"
                                  trim
                                  rows="2"
                                  class="mx-1"
                                  style="width: 100%; max-height: 60px;"
                                />
                              </td>
                            </tr>
                          </table>
                        </b-col>
                      </b-row>
                    </b-container>
                  </b-card-text>
                </b-tab>
                <b-tab :title-link-class="bTabClass(1)" title="Contactos" :disabled="!ready">
                  <b-card-text>
                    <b-container fluid>
                      <b-row style="min-height: 220px">
                        <b-col lg="6" sm="12">
                          <span class="pl-1 text-primary" style="text-decoration: underline;">Datos cliente</span>
                          <table v-if="ready" class="table table-borderless table-show table-sm"  style="font-size: 1rem">
                            <tr>
                              <td style="width: 230px">Correo facturación:</td>
                              <td v-if="client.email">
                                <p v-for="email in client.email.split(';')" :key="email" class="mb-0">
                                  {{ email.trim() }}
                                </p>
                              </td>
                              <td v-else class="text-danger"> Sin información</td>
                            </tr>
                            <tr>
                              <td>Teléfono1:</td>
                              <td v-if="client.phone">
                                {{ client.phone }}
                                <span v-show="client.phone_extension">ext - {{ client.phone_extension }}</span>
                              </td>
                              <td v-else class="text-danger"> Sin información</td>
                            </tr>
                            <tr>
                              <td>Teléfono2:</td>
                              <td v-if="client.phone_2">{{ client.phone_2 }}</td>
                              <td v-else class="text-danger"> Sin información</td>
                            </tr>
                            <tr>
                              <td>Celular:</td>
                              <td v-if="client.cellular">{{ client.cellular }}</td>
                              <td v-else class="text-danger"> Sin información</td>
                            </tr>
                            <tr>
                              <td>Fax:</td>
                              <td v-if="client.fax">{{ client.fax }}</td>
                              <td v-else class="text-danger"> Sin información</td>
                            </tr>
                          </table>
                        </b-col>
                        <b-col lg="6" sm="12">
                          <span class="pl-1 text-primary" style="text-decoration: underline;">Contacto principal</span>
                          <table v-if="ready" class="table table-borderless table-show table-sm"  style="font-size: 1rem">
                            <tr>
                              <td style="width: 230px">Nombre:</td>
                              <td v-if="primaryContact.name">{{primaryContact.name}}</td>
                              <td v-else class="text-danger">-</td>
                            </tr>
                            <tr>
                              <td style="width: 230px">Email:</td>
                              <td v-if="primaryContact.email">{{primaryContact.email}}</td>
                              <td v-else class="text-danger">-</td>
                            </tr>
                            <tr>
                              <td style="width: 230px">Teléfono 1:</td>
                              <td v-if="primaryContact.phone">
                                {{primaryContact.phone}} <span v-if="primaryContact.phone_extension"> ext {{primaryContact.phone_extension}}</span>
                              </td>
                              <td v-else class="text-danger">-</td>
                            </tr>
                            <tr>
                              <td style="width: 230px">Celular:</td>
                              <td v-if="primaryContact.phone">{{primaryContact.cellular}}</td>
                              <td v-else class="text-danger">-</td>
                            </tr>
                            <tr>
                              <td style="width: 230px">Dirección:</td>
                              <td v-if="primaryContact.address">{{primaryContact.address}}</td>
                              <td v-else class="text-danger">-</td>
                            </tr>
                            <tr>
                              <td></td>
                              <td>
                                <Button size="sm" class="py-0" @click="openContactsModal">
                                  <font-awesome-icon :icon="['far', 'address-card']" fixed-width />
                                  <span class="pl-2">Personas de contacto</span>
                                </Button>
                              </td>
                            </tr>
                          </table>
                        </b-col>
                      </b-row>
                    </b-container>
                  </b-card-text>
                </b-tab>
                <b-tab :title-link-class="bTabClass(2)"  title="Direcciones" :disabled="!ready">
                  <b-card-text>
                    <b-container fluid>
                      <b-row v-if="ready" style="min-height: 220px">
                        <span v-if="addresses.length > 0" class="pl-1 text-primary" style="text-decoration: underline;">Dirección principal</span>
                        <table v-if="addresses.length > 0" class="table table-borderless table-show table-sm"  style="font-size: 1rem">
                          <tr>
                            <td style="width: 230px">Nombre dirección:</td>
                            <td v-if="addresses[0].address">{{addresses[0].address}}</td>
                            <td v-else class="text-danger">Falta nombre de dirección</td>
                          </tr>
                          <tr>
                            <td>Dirección:</td>
                            <td v-if="addresses[0].street">{{addresses[0].street}}</td>
                            <td v-else class="text-danger">Falta dirección</td>
                          </tr>
                          <tr>
                            <td>Provincia:</td>
                            <td v-if="addresses[0].province">{{addresses[0].province}}</td>
                            <td v-else class="text-danger">Falta provincia</td>
                          </tr>
                          <tr>
                            <td>Cantón:</td>
                            <td v-if="addresses[0].canton">{{addresses[0].canton}}</td>
                            <td v-else class="text-danger">Falta canton</td>
                          </tr>
                          <tr>
                            <td>Distrito:</td>
                            <td v-if="addresses[0].district">{{addresses[0].district}}</td>
                            <td v-else class="text-danger">Falta distrito</td>
                          </tr>
                          <tr>
                            <td></td>
                            <td>
                              <Button size="sm" class="py-0" @click="addressesModalShow = true">
                                <font-awesome-icon :icon="['fas', 'map-marker-alt']" fixed-width />
                                <span class="pl-2">Direcciones</span>
                              </Button>
                            </td>
                          </tr>
                        </table>
                        <b-container v-else fluid class="fs-17">
                          <b-row align-h="center" class="h-100 justify-content-center align-items-center">
                            <span class="text-danger">Cliente sin direcciones registradas</span>
                          </b-row>
                        </b-container>
                      </b-row>
                    </b-container>
                  </b-card-text>
                </b-tab>
                <b-tab :title-link-class="bTabClass(3)" title="Notas facturación" :disabled="!ready">
                  <b-card-text>
                    <b-container fluid>
                      <p class="pl-1 text-primary mb-0" style="text-decoration: underline;">Facturación automática</p>
                      <div v-if="ready && (client.client_billing_note && Object.keys(client.client_billing_note).length > 0)" style="min-height: 220px">
                        <b-row>
                          <b-col lg="6" sm="12">
                            <table class="table table-borderless table-show table-sm mb-0" style="font-size: 1rem">
                              <b-tr>
                                <b-td style="min-width: 13.0625rem">Requiere OC:</b-td>
                                <b-td v-if="client.client_billing_note.purchase_order_required"> <font-awesome-icon :icon="['far', 'check']" size="lg" fixed-width class="text-success" /> </b-td>
                                <b-td v-else> <font-awesome-icon :icon="['far', 'times']" size="lg" fixed-width class="text-danger" /></b-td>
                              </b-tr>
                              <b-tr>
                                <b-td>Requiere crédito:</b-td>
                                <b-td v-if="client.client_billing_note.credit_required"> <font-awesome-icon :icon="['far', 'check']" size="lg" fixed-width class="text-success" /></b-td>
                                <b-td v-else> <font-awesome-icon :icon="['far', 'times']" size="lg" fixed-width class="text-danger" /></b-td>
                              </b-tr>
                              <b-tr>
                                <b-td>Es exento:</b-td>
                                <b-td v-if="client.client_billing_note.exonerated"><font-awesome-icon :icon="['far', 'check']" size="lg" fixed-width class="text-success" /></b-td>
                                <b-td v-else> <font-awesome-icon :icon="['far', 'times']" size="lg" fixed-width class="text-danger" /></b-td>
                              </b-tr>
                              <b-tr>
                                <b-td>Correo de facturación:</b-td>
                                <b-td v-if="client.client_billing_note.has_billing_mail"><font-awesome-icon :icon="['far', 'check']" size="lg" fixed-width class="text-success" /></b-td>
                                <b-td v-else> <font-awesome-icon :icon="['far', 'times']" size="lg" fixed-width class="text-danger" /></b-td>
                              </b-tr>
                              <b-tr>
                                <b-td>Facturación en colones:</b-td>
                                <b-td v-if="client.client_billing_note.local_currency"><font-awesome-icon :icon="['far', 'check']" size="lg" fixed-width class="text-success" /></b-td>
                                <b-td v-else> <font-awesome-icon :icon="['far', 'times']" size="lg" fixed-width class="text-danger" /></b-td>
                              </b-tr>
                            </table>
                          </b-col>
                          <b-col lg="6" sm="12">
                            <table class="table table-borderless table-show table-sm mb-0" style="font-size: 1rem">
                              <b-tr>
                                <b-td>Trámite físico:</b-td>
                                <b-td v-if="client.client_billing_note.physical_procedure"><font-awesome-icon :icon="['far', 'check']" size="lg" fixed-width class="text-success" /></b-td>
                                <b-td v-else><font-awesome-icon :icon="['far', 'times']" size="lg" fixed-width class="text-danger" /></b-td>
                              </b-tr>
                              <b-tr>
                                <b-td>Portal de documentos:</b-td>
                                <b-td v-if="client.client_billing_note.document_portal"><font-awesome-icon :icon="['far', 'check']" size="lg" fixed-width class="text-success" /></b-td>
                                <b-td v-else> <font-awesome-icon :icon="['far', 'times']" size="lg" fixed-width class="text-danger" /></b-td>
                              </b-tr>
                              <b-tr>
                                <b-td>Anticipos:</b-td>
                                <b-td v-if="client.client_billing_note.advance_payment"><font-awesome-icon :icon="['far', 'check']" size="lg" fixed-width class="text-success" /></b-td>
                                <b-td v-else> <font-awesome-icon :icon="['far', 'times']" size="lg" fixed-width class="text-danger" /></b-td>
                              </b-tr>
                              <b-tr>
                                <b-td >Envío de anexos:</b-td>
                                <b-td v-if="client.client_billing_note.mailing_attachments"><font-awesome-icon :icon="['far', 'check']" size="lg" fixed-width class="text-success" /></b-td>
                                <b-td v-else> <font-awesome-icon :icon="['far', 'times']" size="lg" fixed-width class="text-danger" /></b-td>
                              </b-tr>
                              <b-tr>
                                <b-td >Zona Franca o Diplomática:</b-td>
                                <b-td v-if="client.client_billing_note.is_free_zone_or_diplomatic"><font-awesome-icon :icon="['far', 'check']" size="lg" fixed-width class="text-success" /></b-td>
                                <b-td v-else> <font-awesome-icon :icon="['far', 'times']" size="lg" fixed-width class="text-danger" /></b-td>
                              </b-tr>
                            </table>
                          </b-col>
                        </b-row>
                        <b-row>
                          <b-col>
                            <p class="mb-1 px-1">Comentarios adicionales:</p>
                            <b-textarea
                              disabled
                              id="client-notes"
                              v-model="client.client_billing_note.notes"
                              placeholder="Sin comentarios"
                              trim
                              rows="2"
                              class="mx-1"
                              style="width: 100%; max-height: 60px;"
                            />
                          </b-col>
                        </b-row>
                      </div>
                      <b-row v-else style="min-height: 195px">
                        <b-container fluid class="fs-17">
                          <b-row align-h="center" class="h-100 justify-content-center align-items-center">
                            <span class="text-danger">Cliente sin notas de facturación</span>
                          </b-row>
                        </b-container>
                      </b-row>
                    </b-container>
                  </b-card-text>
                </b-tab>
                <b-tab :title-link-class="bTabClass(4)" title="Requerimientos" :disabled="!ready">
                  <b-card-text>
                    <b-container fluid>
                      <b-row v-if="ready && client.client_requirements.length > 0" style="min-height: 220px">
                        <b-col class="px-0">
                          <b-container fluid class="px-0" >
                            <b-form-group style="width: 100%">
                              <b-input-group>
                                <b-input
                                  v-model="searchRequirementsTerm"
                                  placeholder="Buscar por nombre o categoría"
                                />
                                <b-input-group-append>
                                  <b-button variant="outline-secondary" @click="searchRequirementsTerm = ''">
                                    <font-awesome-icon :icon="['far', 'undo-alt']" fixed-width />
                                  </b-button>
                                </b-input-group-append>
                              </b-input-group>
                            </b-form-group>
                          </b-container>
                          <b-table-simple
                            small
                            responsive
                            style="font-size: medium;"
                          >
                            <b-thead>
                              <b-tr class="font-weight-bold">
                                <b-td style="width: 300px;">Nombre:</b-td>
                                <b-td style="width: 300px;">Categoría:</b-td>
                                <b-td class="text-center" style="width: auto;">Descripción:</b-td>
                              </b-tr>
                            </b-thead>
                            <b-tbody v-if="requirements.length > 0">
                              <b-tr v-for="requirement in requirements" :key="requirement.id">
                                <b-td>
                                  <span v-if="requirement.name" class="font-weight-bold">{{ requirement.name }}</span>
                                  <span v-else> - </span>
                                </b-td>
                                <b-td>
                                  <span v-if="requirement.category">{{ requirement.category }}</span>
                                  <span v-else> - </span>
                                </b-td>
                                <b-td>
                                  <span v-if="requirement.description">{{ requirement.description }}</span>
                                  <span v-else> - </span>
                                </b-td>
                              </b-tr>
                            </b-tbody>
                            <b-tbody v-else>
                              <b-tr>
                                <b-td colspan="3" class="text-center">
                                  <span class="text-danger">Búsqueda sin resultados</span>
                                </b-td>
                              </b-tr>
                            </b-tbody>
                          </b-table-simple>
                        </b-col>
                      </b-row>
                      <b-row v-else style="min-height: 220px">
                        <b-container fluid class="fs-17">
                          <b-row align-h="center" class="h-100 justify-content-center align-items-center">
                            <span class="text-danger fs-17">Cliente sin requerimientos registrados</span>
                          </b-row>
                        </b-container>
                      </b-row>
                    </b-container>
                  </b-card-text>
                </b-tab>
              </b-tabs>
            </b-card>
            <small class="float-right" style="color: #1d58b7">Ultima actualización: <span v-if="client">{{ client.updated_at | formatDateTime }}</span></small>
          </b-col>
        </b-row>

        <!-- Projects section  -->
        <b-row align-h="center">
          <b-col>
            <ShowProjects
              :projects="projects"
              :ready="ready"
              :isLoading="isLoading"
              @addProjectToState="addProjectToState"
              @updateProjectInState="updateProjectInState"
              @displayAlert="displayAlert"
            />
          </b-col>
        </b-row>
      </b-col>
    </b-row>

    <!-- Contacts Modal -->
    <b-modal v-model="contactsModalShow" @hide="searchContactsTerm = ''" title="Personas de contacto" scrollable size="xl" class="p-0" hide-footer>
      <b-row align-h="between">
        <b-col cols="12">
          <b-form-group style="width: 100%">
            <b-input-group>
              <b-input
                v-model="searchContactsTerm"
                placeholder="Buscar por nombre email o teléfono"
              />
              <b-input-group-append>
                <b-button variant="outline-secondary" @click="searchContactsTerm = ''">
                  <font-awesome-icon :icon="['far', 'undo-alt']" fixed-width />
                </b-button>
              </b-input-group-append>
            </b-input-group>
          </b-form-group>
        </b-col>
      </b-row>
      <b-row align-h="end">
        <b-table-simple
          small
          striped
          class="mx-3 fs-16 table-contacts"
        >
          <b-thead>
            <b-tr class="font-weight-bold">
              <b-th sticky-column style="width: 17rem;">Nombre</b-th>
              <b-th style="width: 20rem;">Email</b-th>
              <b-th style="width: 10rem;">Puesto</b-th>
              <b-th style="width: 10rem;">Teléfono 1</b-th>
              <b-th>Teléfono 2</b-th>
              <b-th>Celular</b-th>
              <b-th class="text-center">Activo</b-th>
            </b-tr>
          </b-thead>
          <b-tbody v-if="contacts.length > 0">
            <b-tr v-for="contact in contacts" :key="contact.id" :variant="bgContactVariant(contact.name)">
              <b-td v-if="contact.name" class="font-weight-bold">
                <div>
                  {{ contact.name }}
                  <sup v-if="contact.name == client.contact_person" class="font-weight-bold text-danger pl-1">
                    <b-badge variant="primary">Principal</b-badge>
                  </sup>
                </div>
              </b-td>
              <b-td v-else></b-td>
              <b-td v-if="contact.email">
                <p v-for="(email, index) in contact.email.split(';')" :key="index">
                  <span>{{email}}</span>
                </p>
              </b-td>
              <b-td v-else></b-td>
              <b-td v-if="contact.profession">
                {{ contact.profession }}
              </b-td>
              <b-td v-else></b-td>
              <b-td v-if="contact.phone">
                {{ contact.phone }}
                <span v-if="contact.phone_extension"> ext {{ contact.phone_extension }}</span>
              </b-td>
              <b-td v-else></b-td>
              <b-td v-if="contact.phone_2">{{ contact.phone_2 }}</b-td>
              <b-td v-else></b-td>
              <b-td v-if="contact.cellular">{{ contact.cellular }}</b-td>
              <b-td v-else></b-td>
              <b-td v-if="contact.is_active" class="text-center"><font-awesome-icon :icon="['far', 'check']" size="lg" fixed-width class="text-success" /></b-td>
              <b-td v-else class="text-center"> <font-awesome-icon :icon="['far', 'times']" size="lg" fixed-width class="text-danger" /> </b-td>
            </b-tr>
          </b-tbody>
          <b-tbody v-else>
            <b-tr>
              <b-td colspan="6" class="text-center">
                <span class="text-danger">Búsqueda sin resultados</span>
              </b-td>
            </b-tr>
          </b-tbody>
        </b-table-simple>
      </b-row>
    </b-modal>

    <!-- Addresses Modal -->
    <b-modal v-model="addressesModalShow" @hide="searchAddressesTerm = ''"  title="Direcciones" scrollable class="p-0"  size="xl" hide-footer>
      <b-row align-h="between">
        <b-col cols="12">
          <b-form-group style="width: 100%">
            <b-input-group>
              <b-input
                v-model="searchAddressesTerm"
                placeholder="Buscar por nombre dirección o provincia"
              />
              <b-input-group-append>
                <b-button variant="outline-secondary" @click="searchAddressesTerm = ''">
                  <font-awesome-icon :icon="['far', 'undo-alt']" fixed-width />
                </b-button>
              </b-input-group-append>
            </b-input-group>
          </b-form-group>
        </b-col>
      </b-row>
      <b-row align-h="end">
        <b-table-simple
          small
          responsive
          striped
          class="text-muted mx-3 fs-16"
        >
          <b-thead>
            <b-tr class="font-weight-bold">
              <b-td style="width: 20rem;">Nombre dirección</b-td>
              <b-td style="width: 30rem;">Dirección</b-td>
              <b-td>Provincia</b-td>
              <b-td>Cantón</b-td>
              <b-td>Distrito</b-td>
            </b-tr>
          </b-thead>
          <b-tbody v-if="addressesModal.length > 0">
            <b-tr v-for="address in addressesModal" :key="address.id" :variant="bgAddressVariant(address.address)">
              <b-td v-if="address.address" class="font-weight-bold">
                <div>
                  {{ address.address }}
                  <sup v-if="address.address == client.default_address" class="font-weight-bold text-danger pl-1">
                    <b-badge variant="primary">Principal</b-badge>
                  </sup>
                </div>
              </b-td>
              <b-td v-else></b-td>
              <b-td v-if="address.street" >{{ address.street }}</b-td>
              <b-td v-else></b-td>
              <b-td v-if="address.province">{{ address.province }}</b-td>
              <b-td v-else></b-td>
              <b-td v-if="address.canton">{{ address.canton }}</b-td>
              <b-td v-else></b-td>
              <b-td v-if="address.district">{{ address.district }}</b-td>
              <b-td v-else></b-td>
            </b-tr>
          </b-tbody>
          <b-tbody v-else>
            <b-tr>
              <b-td colspan="6" class="text-center">
                <span class="text-danger">Búsqueda sin resultados</span>
              </b-td>
            </b-tr>
          </b-tbody>
        </b-table-simple>
      </b-row>
    </b-modal>

    <!-- PaymentTerms Modal -->
    <b-modal  v-if="isDev" v-model="paymentTermsModalShow" centered title="Editar condiciones de pago">
      <b-row align-h="center">
        <b-form-group label="Condiciones de pago" label-size="sm" style="width: 300px">
          <b-select v-model="paymentTermsForm.sap_payment_terms_code" :options="paymentTermsOptions" size="sm">
            <template #first>
              <b-select-option :value="null">- Eligir una opción -</b-select-option>
            </template>
          </b-select>
        </b-form-group>
      </b-row>
      <template #modal-footer>
        <Button variant="green" :disabled="!paymentTermsForm.sap_payment_terms_code" @click="updatePaymentTerms">Guardar</Button>
      </template>
    </b-modal>

    <!-- ConfirmModal -->
    <ConfirmModal v-if="confirmModal" :required=true @close="confirmModal = false" @onConfirm="inactivate">
      <template #header>
        <h5>Inactivar cliente en XYZ</h5>
      </template>
      <template #body>
        <div>
          <p class="fs-5 font-weight-bold">¿Está seguro que desea inactivar el cliente?</p>
          <p class="text-muted text-center">NOTA: Se inactivará el cliente en XYZ, el proceso es irreversible</p>
        </div>
        <b-textarea
          size="sm"
          rows="4"
          placeholder="Indique el motivo de la inactivación"
          v-model="inactivateNotes"
        ></b-textarea>
      </template>
    </ConfirmModal>

    <!-- Alert -->
    <ToastAlert :show="alertShow" :variant="alertVariant" @close="alertShow = false">
      {{ alertMessage }}
    </ToastAlert>

  </b-container>
</template>

<script>
import { mapGetters } from 'vuex'
import { normalize, schema } from 'normalizr'

import Header from './Header'
import ShowProjects from './ShowProjects'
import ClientDashboards from './ClientDashboards'
import Button from '../../shared/Button'
import ConfirmModal from '../../shared/ConfirmModal'
import ToastAlert from '../../shared/ToastAlert'
import { provinces } from '../../../sharedOptions/provinces'
import {
  subSectors
} from '../../../sharedOptions/businessPartners'

export default {
  name: 'ClientShow',
  components: {
    Button, ToastAlert, Header, ShowProjects, ConfirmModal, ClientDashboards
  },
  data () {
    return {
      id: Number(this.$route.params.id),
      processing: false,
      isLoading: false,
      isDashboardLoading: false,
      ready: false,
      client: null,
      contactData: [],
      paymentTerms: [],
      projectData: {},
      projectList: [],
      addressData:  {},
      addressList: [],
      billingNote: {},
      contactsModalShow: false,
      addressesModalShow: false,
      paymentTermsModalShow: false,
      paymentTermsForm: {
        sap_payment_terms_code: null
      },
      provinceNames: provinces,
      alertShow: false,
      alertVariant: null,
      alertMessage: '',
      bTabIndex: 0,
      searchContactsTerm: '',
      searchAddressesTerm: '',
      searchRequirementsTerm: '',
      subSectorMapping: subSectors,
      isInactivatingClient: false,
      confirmModal: false,
      inactivateNotes: ''
    }
  },
  computed: {
    ...mapGetters(['isAdmin', 'isDev', 'isClientAdmin']),
    paymentTermsOptions () {
      return this.paymentTerms.map(term => ({ text: term.name, value: term.sap_group_number }))
    },
    projects () {
      let array = this.projectList.map(id => this.projectData[id])
      return array.sort((a,b) => new Date(b.created_at) - new Date(a.created_at))
    },
    addresses () {
      let newAddresses = this.addressList.map(id => {
        const original = this.addressData[id]
        const address = { ...original }

        const provinceName = this.provinceNames.find(el => el.value == address.province)

        if (provinceName) { address.province = provinceName.text }

        address.sap_line_num = address.address === this.client.default_address ? 0 : 1

        return address
      })

      return newAddresses.sort((a, b) => {
        if (a.sap_line_num !== b.sap_line_num) {
          return a.sap_line_num - b.sap_line_num
        }
        return (a.address || '').localeCompare(b.address || '')
      })
    },
    addressesModal () {
      const filteredAddresses = [...this.addresses].filter(val => {
        if (this.searchAddressesTerm) {
          const term = this.searchAddressesTerm.toLowerCase()
          return (
            val?.address?.toLowerCase().includes(term) ||
            (val?.province?.toLowerCase().includes(term)) ||
            (val?.street?.toLowerCase().includes(term))
          )
        }
        return true
      })
      return filteredAddresses
    },
    contacts () {
      if (!this.contactData) return []

      return this.contactData.map(val => ({
          ...val,
          position: val.name === this.client.contact_person ? 0 : 1
        })).filter(val => {
          if (this.searchContactsTerm) {
            const term = this.searchContactsTerm.toLowerCase()
            return (
              (val.name || '').toLowerCase().includes(term) ||
              (val.email || '').toLowerCase().includes(term) ||
              (val.phone || '').toLowerCase().includes(term)
            )
          }
          return true
        }).sort((a, b) => {
          if (a.position !== b.position) {
            return a.position - b.position
          }
          return (a.name || '').localeCompare(b.name || '')
        })
    },
    primaryContact () {
      if (!this.ready || this.contactData.length == 0) return {}
      const contact = this.contactData.find(contact => contact.name == this.client.contact_person)
      return contact || {}
    },
    clientTaxCode () {
      if (!this.ready || this.addresses.length == 0) return ''
      const address = this.addresses.find(address => address.address == this.client.default_address) || this.addresses[0]
      return address.tax_code || ''
    },
    requirements () {
      const requirements = this.client.client_requirements
      return requirements.filter(requirement => {
        if (this.searchRequirementsTerm) {
          const term = this.searchRequirementsTerm.toLowerCase()
          return (
            requirement.name.toLowerCase().includes(term) ||
            (requirement.category && requirement.category.toLowerCase().includes(term))
          )
        }
        return true
      })
    },
    currentUser () { return this.$store.state.currentUser },
    cedulaType () {
      let type
      if (this.client && this.client.sap_gln) {
        switch (this.client.sap_gln) {
          case '01':
            type = 'Cédula Física'
            break;
          case '02':
            type = 'Cédula Jurídica'
            break;
          case '03':
            type = 'DIMEX'
            break;
          case '04':
            type = 'NITE'
            break;
          case '00':
            type = 'Extranjero'
            break;
          default:
            type = ''
        }
      }
      return type
    },
    subSectorName () {
      if (!this.client.subsector || !this.client.industry) return ''
      const subSector = this.subSectorMapping[this.client.industry]
                            ?.find(o => o.value == this.client.subsector)
                            || { text: 'No definido' }
      return subSector.text
    }
  },
  mounted () {
    this.fetchClientData()
  },
  methods: {
    fetchClientData () {
      this.ready = false
      this.isLoading = true
      this.$http.get(`/api/production/clients/${this.id}`)
        .then((res) => {
          // this.fetchDashboard()
          // console.log(res.data)

          this.client = res.data.client
          this.client['salesperson'] = res.data.salesperson
          this.client['telemarketer'] = res.data.telemarketer
          // Projects
          const projectData = normalize(
            { projects: res.data.client.projects },
            { projects: [ new schema.Entity('projects') ] }
          )
          if (projectData.entities.hasOwnProperty('projects')) { // in case of empty data
            this.projectData = projectData.entities.projects
          } else {
            this.projectData = {}
          }
          this.projectList = projectData.result.projects

          // Addresses
          const addressData = normalize(
            { addresses: res.data.client.client_addresses },
            { addresses: [new schema.Entity('addresses') ] }
          )
          if (addressData.entities.hasOwnProperty('addresses')) {
            this.addressData = addressData.entities.addresses
          } else {
            this.addressData = {}
          }
          this.addressList = addressData.result.addresses
          this.contactData = res.data.client.client_contacts

          // seed detailShow and loading in project data
          for (var key in this.projectData) {
            if (this.projectData.hasOwnProperty(key)) {
              this.$set(this.projectData[key], 'detailShow', false)
              this.$set(this.projectData[key], 'loading', false)
            }
          }
          this.ready = true
          delete this.client['client_contacts']
          delete this.client['client_addresses']
          delete this.client['projects']
        })
        .catch(e => console.log(e))
        .finally(() => this.isLoading = false)
    },
    openContactsModal () {
      this.contactsModalShow = true
    },
    openPaymentTermsModal () {
      this.paymentTermsForm.sap_payment_terms_code = this.client.sap_payment_terms_code
      this.$http.get('/api/production/payment_terms_types')
        .then(response => {
          // console.log(response)
          this.paymentTerms = response.data
          this.paymentTermsModalShow = true
        })
        .catch(error => {
          console.log(error)
        })
    },
    updatePaymentTerms () {
      if (this.processing) return
      this.processing = true
      this.$http.put(`/api/production/clients/${this.client.id}`, {
          client: this.paymentTermsForm
        })
        .then(response => {
          // console.log(response)
          this.client.payment_terms = response.data.payment_terms
          this.client.sap_payment_terms_code = response.data.sap_payment_terms_code
          this.displayAlert({ message: 'Cambios se guardaron', variant: 'success' })
        })
        .catch(error => {
          console.log(error)
          this.displayAlert({ message: 'No funcionó', variant: 'danger' })
        })
        .finally(() => {
          this.processing = false
          this.paymentTermsModalShow = false
          this.alertShow = true
        })
    },
    bTabClass (ind) {
      if (this.bTabIndex === ind) {
        return ['font-weight-bold']
      } else {
        return ['text-muted']
      }
    },
    bgContactVariant (value) {
      if (this.contacts && value == this.client.contact_person) {
        return 'info'
      }
    },
    bgAddressVariant (value) {
      if (this.addresses && value == this.client.default_address) {
        return 'info'
      }
    },
    displayAlert ({ message, variant }) {
      this.alertVariant = variant
      this.alertMessage = message
      this.alertShow = true
      setTimeout(() => this.alertShow = false, 2000)
    },
    updateClientState (newClientData) {
      this.client = {
        ...this.client,
        ...newClientData
      }
    },
    addProjectToState (newProject) {
      this.$set(this.projectData, newProject.id, newProject)
      this.projectList.unshift(newProject.id)
      this.displayAlert({ message: 'El proyecto se ha creado con éxito', variant: 'success' })
    },
    updateProjectInState (newProjectData) {
      const { id, name, address, project_type, manager } = newProjectData

      this.projectData[id].name = name
      this.projectData[id].address = address
      this.projectData[id].project_type = project_type
      this.projectData[id].manager = manager

      this.displayAlert({ message: 'Proyecto actualizado correctamente', variant: 'success' })
    },
    inactivate () {
      if (this.processing) return
      this.confirmModal = false
      this.isInactivatingClient = true
      this.$http.patch(`/api/production/clients/${this.client.id}/inactivate`,
        { inactivate_notes: this.inactivateNotes }
      )
        .then((resp) => {
          this.inactivateNotes = ''
          this.updateClientState({
            sap_valid: resp.data.sap_valid,
            sap_frozen: resp.data.sap_frozen,
            sap_frozen_remarks: resp.data.sap_frozen_remarks
          })
          this.displayAlert({
            message: 'Cliente inactivado correctamente',
            variant: 'success'
          })
        })
        .catch((err) => {
          console.error(err)
          this.displayAlert({
            message: 'No funcionó, por favor intente de nuevo',
            variant: 'danger'
          })
        })
        .finally(() => this.isInactivatingClient = false)
    },
    isValidUrl (url) {
      if (!url || typeof url !== 'string') return false

      try {
        new URL(url.startsWith('http') ? url : `https://${url}`)
        return true
      } catch {
        return false
      }
    },
    // dashboards
    fetchDashboard() {
      this.isDashboardLoading = true
      setTimeout(() => this.isDashboardLoading = false, 3000)
    },
    updateDashboards (dashboards) {
      this.dashboardCards = dashboards || {}
    }
  }
}
</script>

<style scoped>
.table-contacts td {
  white-space: normal;
  word-wrap: break-word;
  word-break: break-all;
}
.tabs-card {
  border-radius: 8px;
  border: 2px solid #e2e8f0;
  min-height: 265px;
}
</style>
